module.exports = __webpack_public_path__ + "media/1.1c7fe800.mp3";